import moment from 'moment';

/**
 * The bonus period whose date range contains today, or undefined if none does.
 * Used to default content surfaces (boards/dashboards/reports) of a sub-period
 * programme to the current period, so the sub-period default (the most recently
 * completed week — see getDefaultSubPeriod) resolves within it. Approvals does
 * NOT use this; it keeps the status-priority default (getDefaultBonusPeriod).
 */
const getBonusPeriodContainingToday = (
  bonusPeriods: BonusPeriod[] | BonusTypes.BonusPeriod[],
): BonusPeriod | BonusTypes.BonusPeriod | undefined => {
  const today = moment().format('YYYY-MM-DD');
  return bonusPeriods.find(
    (period) => period.startDate <= today && today <= period.endDate,
  );
};

export default getBonusPeriodContainingToday;
